import { gql } from "@apollo/client";

const CONFIG_PORTAL_CREDENTIAL_FIELDS = `
  id
  purchaserId
  purchaserName
  purchaserKey
  dataProviderTypeId
  portalUserName
  portalPassword
  portalKey
  isActive
  metadata
`;

export const GET_CONFIG_PORTAL_CREDENTIALS = gql`
  query ConfigPortalCredentials($params: ConfigPortalCredentialsParamsInput!) {
    configPortalCredentials(params: $params) {
      total
      page
      limit
      items {
        ${CONFIG_PORTAL_CREDENTIAL_FIELDS}
      }
    }
  }
`;

export const CREATE_CONFIG_PORTAL_CREDENTIAL = gql`
  mutation CreateConfigPortalCredential(
    $params: CreateConfigPortalCredentialInput!
  ) {
    createConfigPortalCredential(params: $params) {
      ${CONFIG_PORTAL_CREDENTIAL_FIELDS}
    }
  }
`;

export const UPDATE_CONFIG_PORTAL_CREDENTIAL = gql`
  mutation UpdateConfigPortalCredential(
    $params: UpdateConfigPortalCredentialInput!
  ) {
    updateConfigPortalCredential(params: $params) {
      ${CONFIG_PORTAL_CREDENTIAL_FIELDS}
    }
  }
`;

export const DELETE_CONFIG_PORTAL_CREDENTIAL = gql`
  mutation DeleteConfigPortalCredential(
    $params: DeleteConfigPortalCredentialInput!
  ) {
    deleteConfigPortalCredential(params: $params) {
      id
      message
    }
  }
`;

export const GET_PURCHASER_PORTAL_KEYS_BY_KEY = gql`
  query PurchaserPortalKeysByPurchaserKey($purchaserKey: String!) {
    purchaserPortalKeys(purchaserKey: $purchaserKey) {
      id
      portalKeyName
      portalKey
      appPurchaserId
      purchaserKey
    }
  }
`;
